<div class="border-box-darkgrey p-xl-4">
  <div class="row">
    <div class="col">
      <h5>Os meus dados de entrega</h5>
    </div>
    <div class="col-auto">
      <button type="button" (click)="showDataToggle()" class="btn-black">{{textButton}}</button>
    </div>
  </div>
  <hr>


  <div *ngIf="showData">
    <form [formGroup]="dataform" (ngSubmit)="saveEvent()">
      <div class="lead"><strong>Nova morada de entrega</strong></div>
      <div class="row">
        <div class="col-xl-4 mb-3">
          <label for="Addressee">Nome comercial do destinatário</label>
          <input formControlName="Addressee" type="text" class="form-control" id="Addressee" [ngClass]="{'is-invalid':dataform.get('Addressee').invalid && (!dataform.get('Addressee').pristine || submitted == 1) , 'is-valid':dataform.get('Addressee').valid && !dataform.get('Addressee').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['Addressee'].errors || !dataform.controls['Addressee'].errors['required']">
             Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['Addressee'].errors || !dataform.controls['Addressee'].errors['maxLength']">
              Limite de caracteres excedido.
            </div>
          </div>

        </div>
        <div class="col-sm-6 col-xl-4 mb-3">
          <label for="Contact">Pessoa de contacto</label>
          <input formControlName="Contact" type="text" class="form-control" id="Contact" [ngClass]="{'is-invalid':dataform.get('Contact').invalid && (!dataform.get('Contact').pristine || submitted == 1) , 'is-valid':dataform.get('Contact').valid && !dataform.get('Contact').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['Contact'].errors || !dataform.controls['Contact'].errors['required']">
             Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['Contact'].errors || !dataform.controls['Contact'].errors['maxLength']">
              Limite de caracteres excedido.
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-xl-4 mb-3">
          <label for="Phone">Telefone</label>
          <input formControlName="Phone" type="text" class="form-control adjust" id="Phone" [ngClass]="{'is-invalid':dataform.get('Phone').invalid && (!dataform.get('Phone').pristine || submitted == 1) , 'is-valid':dataform.get('Phone').valid && !dataform.get('Phone').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['Phone'].errors || !dataform.controls['Phone'].errors['required']">
             Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['Phone'].errors || !dataform.controls['Phone'].errors['maxLength']">
              Limite de caracteres excedido.
            </div>
            <div [hidden]="!dataform.controls['Phone'].errors || !dataform.controls['Phone'].errors['pattern']">
              Só números.
            </div>

          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6 col-xxl-2 mb-3">
          <label for="Mail">E-mail</label>
          <input formControlName="Mail" type="text" class="form-control" id="Mail" placeholder="E-mail" [ngClass]="{'is-invalid':dataform.get('Mail').invalid && (!dataform.get('Mail').pristine || submitted == 1) , 'is-valid':dataform.get('Mail').valid && !dataform.get('Mail').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['Mail'].errors || !dataform.controls['Mail'].errors['required']">
             Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['Mail'].errors || !dataform.controls['Mail'].errors['maxLength']">
              Limite de caracteres excedido.
            </div>
          </div>

        </div>
        <div class="col-sm-6 col-xxl-3 mb-3">
          <label for="Address">Morada</label>
          <input formControlName="AddressStreet" type="text" class="form-control" id="AddressStreet" placeholder="Morada" [ngClass]="{'is-invalid':dataform.get('AddressStreet').invalid && (!dataform.get('AddressStreet').pristine || submitted == 1) , 'is-valid':dataform.get('AddressStreet').valid && !dataform.get('AddressStreet').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['AddressStreet'].errors || !dataform.controls['AddressStreet'].errors['required']">
             Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['AddressStreet'].errors || !dataform.controls['AddressStreet'].errors['maxLength']">
              Limite de caracteres excedido.
            </div>

          </div>
        </div>
        <div class="col-sm-2 col-xxl-1 mb-3">
          <label for="Address">Número</label>
          <input formControlName="AddressNumber" type="text" class="form-control" id="AddressNumber" placeholder="Número" [ngClass]="{'is-invalid':dataform.get('AddressNumber').invalid && (!dataform.get('AddressNumber').pristine || submitted == 1) , 'is-valid':dataform.get('AddressNumber').valid && !dataform.get('AddressNumber').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['AddressNumber'].errors || !dataform.controls['AddressNumber'].errors['required']">
             Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['AddressNumber'].errors || !dataform.controls['AddressNumber'].errors['maxLength']">
              Limite de caracteres excedido.
            </div>
          </div>
        </div>
        <div class="col-sm-2 col-xxl-1 mb-3">
          <label for="Address">C. Postal</label>
          <input formControlName="AddressZip" type="text" class="form-control" id="AddressZip" placeholder="C. Postal" [ngClass]="{'is-invalid':dataform.get('AddressZip').invalid && (!dataform.get('AddressZip').pristine || submitted == 1) , 'is-valid':dataform.get('AddressZip').valid && !dataform.get('AddressZip').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['AddressZip'].errors || !dataform.controls['AddressZip'].errors['required']">
             Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['AddressZip'].errors || !dataform.controls['AddressZip'].errors['maxLength']">
              Limite de caracteres excedido.
            </div>
            <div [hidden]="!dataform.controls['AddressZip'].errors || !dataform.controls['AddressZip'].errors['pattern']">
              Só números.
            </div>

          </div>
        </div>
        <div class="col-sm-4 col-xxl-3 mb-3">
          <label for="Address">Cidade</label>
          <input formControlName="AddressCity" type="text" class="form-control" id="AddressCity" placeholder="Cidade" [ngClass]="{'is-invalid':dataform.get('AddressCity').invalid && (!dataform.get('AddressCity').pristine || submitted == 1) , 'is-valid':dataform.get('AddressCity').valid && !dataform.get('AddressCity').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['AddressCity'].errors || !dataform.controls['AddressCity'].errors['required']">
             Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['AddressCity'].errors || !dataform.controls['AddressCity'].errors['maxLength']">
              Limite de caracteres excedido.
            </div>

          </div>
        </div>
        <div class="col-sm-4 col-xxl-2 mb-3">
          <label for="Address">Distrito</label>
          <input formControlName="AddressRegion" type="text" class="form-control" id="AddressRegion" placeholder="Distrito" [ngClass]="{'is-invalid':dataform.get('AddressRegion').invalid && (!dataform.get('AddressRegion').pristine || submitted == 1) , 'is-valid':dataform.get('AddressRegion').valid && !dataform.get('AddressRegion').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['AddressRegion'].errors || !dataform.controls['AddressRegion'].errors['required']">
             Campo obrigatório.
            </div>
            <div [hidden]="!dataform.controls['AddressRegion'].errors || !dataform.controls['AddressRegion'].errors['maxLength']">
              Limite de caracteres excedido.
            </div>

          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div>
          <label for="Comments">Comentários</label>
          <input formControlName="Comments" type="text" class="form-control" id="Comments" placeholder="Comentários" [ngClass]="{'is-invalid':dataform.get('Comments').invalid && (!dataform.get('Comments').pristine || submitted == 1) , 'is-valid':dataform.get('Comments').valid && !dataform.get('Comments').pristine}">

          <div class="invalid-tooltip">
            <div [hidden]="!dataform.controls['Comments'].errors || !dataform.controls['Comments'].errors['maxLength']">
              Limite de caracteres excedido.
            </div>
          </div>
        </div>
      </div>

      <div class="pt-3 pb-3">
        <div class="d-flex justify-content-end">
          <button type="submit" class="btn-orange"> GUARDAR</button>
        </div>
      </div>
    </form>
    <hr>
  </div>
  <div class="table-responsive-sm">
    <table id="tblEvaluation" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table data-tables dataTable condensed-table no-footer w-100">
      <thead>
        <tr>
          <th class="w-12">Destinatário</th>
          <th class="w-16">Contacto</th>
          <th class="w-25">Morada</th>
          <th class="w-8">Telefone</th>
          <th class="w-16">E-mail</th>
          <th>Comentários</th>
          <th class="text-center w-6">Opções</th>
        </tr>
      </thead>
    </table>
  </div>
</div>